var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataTable',{attrs:{"row-key":"userId","data":_vm.computedData,"columns":_vm.tableColumns,"loading":_vm.pending,"sortable":_vm.sortable,"sortable-columns":[
    'firstname',
    'lastname',
    'username',
    'correct',
    'completed'
  ]},scopedSlots:_vm._u([{key:"correct",fn:function(ref){
  var row = ref.row;
return [_vm._v(" "+_vm._s(((row.correct) + "%"))+" ")]}},{key:"completed",fn:function(ref){
  var row = ref.row;
return [_vm._v(" "+_vm._s(((row.progress) + "%"))+" ")]}},{key:"chart",fn:function(ref){
  var row = ref.row;
return [_c('div',{staticClass:"scores"},[_c('ProgressScore',{attrs:{"data":[row.correct, row.progress]}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }